import Vue from 'vue'
import Notification from 'vt-notifications'

Vue.use(Notification)
